"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var controlTypes_exports = {};
__export(controlTypes_exports, {
  glassEffectShapes: () => glassEffectShapes,
  glassEffects: () => glassEffects,
  materials: () => materials,
  sdkAccentColorValues: () => sdkAccentColorValues,
  sdkAccessibilityActivationPointWithUnitPointValues: () => sdkAccessibilityActivationPointWithUnitPointValues,
  sdkAccessibilityAddTraitsValues: () => sdkAccessibilityAddTraitsValues,
  sdkAccessibilityAdjustableActionValues: () => sdkAccessibilityAdjustableActionValues,
  sdkAccessibilityElementValues: () => sdkAccessibilityElementValues,
  sdkAccessibilityHeadingValues: () => sdkAccessibilityHeadingValues,
  sdkAccessibilityRemoveTraitsValues: () => sdkAccessibilityRemoveTraitsValues,
  sdkAccessibilityScrollActionValues: () => sdkAccessibilityScrollActionValues,
  sdkAccessibilityTextContentTypeValues: () => sdkAccessibilityTextContentTypeValues,
  sdkAccessibilityWithActivationPointValues: () => sdkAccessibilityWithActivationPointValues,
  sdkAccessibilityWithAddTraitsValues: () => sdkAccessibilityWithAddTraitsValues,
  sdkAccessibilityWithRemoveTraitsValues: () => sdkAccessibilityWithRemoveTraitsValues,
  sdkAddPassToWalletButtonStyleValues: () => sdkAddPassToWalletButtonStyleValues,
  sdkAllowedDynamicRangeValues: () => sdkAllowedDynamicRangeValues,
  sdkAnimationValues: () => sdkAnimationValues,
  sdkAsyncImageURLSessionValues: () => sdkAsyncImageURLSessionValues,
  sdkAutocapitalizationValues: () => sdkAutocapitalizationValues,
  sdkBackgroundStyleValues: () => sdkBackgroundStyleValues,
  sdkBadgeProminenceValues: () => sdkBadgeProminenceValues,
  sdkBlendModeValues: () => sdkBlendModeValues,
  sdkButtonBorderShapeValues: () => sdkButtonBorderShapeValues,
  sdkButtonRepeatBehaviorValues: () => sdkButtonRepeatBehaviorValues,
  sdkButtonSizingValues: () => sdkButtonSizingValues,
  sdkButtonStyleValues: () => sdkButtonStyleValues,
  sdkClipShapeValues: () => sdkClipShapeValues,
  sdkColorMultiplyValues: () => sdkColorMultiplyValues,
  sdkColorSchemeValues: () => sdkColorSchemeValues,
  sdkContainerShapeValues: () => sdkContainerShapeValues,
  sdkContentShapeValues: () => sdkContentShapeValues,
  sdkContentTransitionValues: () => sdkContentTransitionValues,
  sdkControlGroupStyleValues: () => sdkControlGroupStyleValues,
  sdkControlSizeValues: () => sdkControlSizeValues,
  sdkDatePickerStyleValues: () => sdkDatePickerStyleValues,
  sdkDefaultAdaptableTabBarPlacementValues: () => sdkDefaultAdaptableTabBarPlacementValues,
  sdkDefaultAppStorageValues: () => sdkDefaultAppStorageValues,
  sdkDefaultHoverEffectValues: () => sdkDefaultHoverEffectValues,
  sdkDefaultScrollAnchorWithOptionalUnitPointValues: () => sdkDefaultScrollAnchorWithOptionalUnitPointValues,
  sdkDefaultTabBarPlacementValues: () => sdkDefaultTabBarPlacementValues,
  sdkDefersSystemGesturesValues: () => sdkDefersSystemGesturesValues,
  sdkDisclosureGroupStyleValues: () => sdkDisclosureGroupStyleValues,
  sdkDropConfigurationValues: () => sdkDropConfigurationValues,
  sdkDynamicTypeSizeValues: () => sdkDynamicTypeSizeValues,
  sdkEdgesIgnoringSafeAreaValues: () => sdkEdgesIgnoringSafeAreaValues,
  sdkEnvironmentAllowedDynamicRangeValues: () => sdkEnvironmentAllowedDynamicRangeValues,
  sdkEnvironmentBackgroundMaterialValues: () => sdkEnvironmentBackgroundMaterialValues,
  sdkEnvironmentBackgroundProminenceValues: () => sdkEnvironmentBackgroundProminenceValues,
  sdkEnvironmentBadgeProminenceValues: () => sdkEnvironmentBadgeProminenceValues,
  sdkEnvironmentCalendarValues: () => sdkEnvironmentCalendarValues,
  sdkEnvironmentColorSchemeValues: () => sdkEnvironmentColorSchemeValues,
  sdkEnvironmentContentTransitionValues: () => sdkEnvironmentContentTransitionValues,
  sdkEnvironmentControlSizeValues: () => sdkEnvironmentControlSizeValues,
  sdkEnvironmentDynamicTypeSizeValues: () => sdkEnvironmentDynamicTypeSizeValues,
  sdkEnvironmentFontValues: () => sdkEnvironmentFontValues,
  sdkEnvironmentHeaderProminenceValues: () => sdkEnvironmentHeaderProminenceValues,
  sdkEnvironmentHorizontalScrollBounceBehaviorValues: () => sdkEnvironmentHorizontalScrollBounceBehaviorValues,
  sdkEnvironmentHorizontalScrollIndicatorVisibilityValues: () => sdkEnvironmentHorizontalScrollIndicatorVisibilityValues,
  sdkEnvironmentHorizontalSizeClassValues: () => sdkEnvironmentHorizontalSizeClassValues,
  sdkEnvironmentImageScaleValues: () => sdkEnvironmentImageScaleValues,
  sdkEnvironmentLabelsVisibilityValues: () => sdkEnvironmentLabelsVisibilityValues,
  sdkEnvironmentLayoutDirectionValues: () => sdkEnvironmentLayoutDirectionValues,
  sdkEnvironmentLegibilityWeightValues: () => sdkEnvironmentLegibilityWeightValues,
  sdkEnvironmentLineHeightValues: () => sdkEnvironmentLineHeightValues,
  sdkEnvironmentLocaleValues: () => sdkEnvironmentLocaleValues,
  sdkEnvironmentMaterialActiveAppearanceValues: () => sdkEnvironmentMaterialActiveAppearanceValues,
  sdkEnvironmentMenuIndicatorVisibilityValues: () => sdkEnvironmentMenuIndicatorVisibilityValues,
  sdkEnvironmentMenuOrderValues: () => sdkEnvironmentMenuOrderValues,
  sdkEnvironmentMultilineTextAlignmentValues: () => sdkEnvironmentMultilineTextAlignmentValues,
  sdkEnvironmentRealityViewCameraControlsValues: () => sdkEnvironmentRealityViewCameraControlsValues,
  sdkEnvironmentRedactionReasonsValues: () => sdkEnvironmentRedactionReasonsValues,
  sdkEnvironmentScenePhaseValues: () => sdkEnvironmentScenePhaseValues,
  sdkEnvironmentScrollDismissesKeyboardModeValues: () => sdkEnvironmentScrollDismissesKeyboardModeValues,
  sdkEnvironmentSidebarRowSizeValues: () => sdkEnvironmentSidebarRowSizeValues,
  sdkEnvironmentSizeCategoryValues: () => sdkEnvironmentSizeCategoryValues,
  sdkEnvironmentSymbolColorRenderingModeValues: () => sdkEnvironmentSymbolColorRenderingModeValues,
  sdkEnvironmentSymbolRenderingModeValues: () => sdkEnvironmentSymbolRenderingModeValues,
  sdkEnvironmentSymbolVariableValueModeValues: () => sdkEnvironmentSymbolVariableValueModeValues,
  sdkEnvironmentSymbolVariantsValues: () => sdkEnvironmentSymbolVariantsValues,
  sdkEnvironmentTextCaseValues: () => sdkEnvironmentTextCaseValues,
  sdkEnvironmentTextSelectionAffinityValues: () => sdkEnvironmentTextSelectionAffinityValues,
  sdkEnvironmentTimeZoneValues: () => sdkEnvironmentTimeZoneValues,
  sdkEnvironmentTruncationModeValues: () => sdkEnvironmentTruncationModeValues,
  sdkEnvironmentVerticalScrollBounceBehaviorValues: () => sdkEnvironmentVerticalScrollBounceBehaviorValues,
  sdkEnvironmentVerticalScrollIndicatorVisibilityValues: () => sdkEnvironmentVerticalScrollIndicatorVisibilityValues,
  sdkEnvironmentVerticalSizeClassValues: () => sdkEnvironmentVerticalSizeClassValues,
  sdkFileDialogBrowserOptionsValues: () => sdkFileDialogBrowserOptionsValues,
  sdkFontDesignWithOptionalDesignValues: () => sdkFontDesignWithOptionalDesignValues,
  sdkFontValues: () => sdkFontValues,
  sdkFontWeightWithOptionalWeightValues: () => sdkFontWeightWithOptionalWeightValues,
  sdkFontWidthValues: () => sdkFontWidthValues,
  sdkForegroundColorValues: () => sdkForegroundColorValues,
  sdkFormStyleValues: () => sdkFormStyleValues,
  sdkGaugeStyleValues: () => sdkGaugeStyleValues,
  sdkGlassEffectTransitionValues: () => sdkGlassEffectTransitionValues,
  sdkGlassEffectWithGlassValues: () => sdkGlassEffectWithGlassValues,
  sdkGridCellAnchorValues: () => sdkGridCellAnchorValues,
  sdkGridCellUnsizedAxesValues: () => sdkGridCellUnsizedAxesValues,
  sdkGridColumnAlignmentValues: () => sdkGridColumnAlignmentValues,
  sdkGroupBoxStyleValues: () => sdkGroupBoxStyleValues,
  sdkHandlesGameControllerEventsValues: () => sdkHandlesGameControllerEventsValues,
  sdkHeaderProminenceValues: () => sdkHeaderProminenceValues,
  sdkHoverEffectWithHoverEffectFromSwiftUICoreValues: () => sdkHoverEffectWithHoverEffectFromSwiftUICoreValues,
  sdkHoverEffectWithHoverEffectValues: () => sdkHoverEffectWithHoverEffectValues,
  sdkHueRotationValues: () => sdkHueRotationValues,
  sdkIgnoresSafeAreaWithSafeAreaRegionsValues: () => sdkIgnoresSafeAreaWithSafeAreaRegionsValues,
  sdkImageScaleValues: () => sdkImageScaleValues,
  sdkIndexViewStyleValues: () => sdkIndexViewStyleValues,
  sdkKeyboardShortcutWithKeyboardShortcutValues: () => sdkKeyboardShortcutWithKeyboardShortcutValues,
  sdkKeyboardShortcutWithOptionalKeyboardShortcutValues: () => sdkKeyboardShortcutWithOptionalKeyboardShortcutValues,
  sdkKeyboardTypeValues: () => sdkKeyboardTypeValues,
  sdkLabelStyleValues: () => sdkLabelStyleValues,
  sdkLabeledContentStyleValues: () => sdkLabeledContentStyleValues,
  sdkLabelsVisibilityValues: () => sdkLabelsVisibilityValues,
  sdkLayoutDirectionBehaviorValues: () => sdkLayoutDirectionBehaviorValues,
  sdkLineHeightValues: () => sdkLineHeightValues,
  sdkListItemTintWithOptionalColorValues: () => sdkListItemTintWithOptionalColorValues,
  sdkListItemTintWithOptionalListItemTintValues: () => sdkListItemTintWithOptionalListItemTintValues,
  sdkListSectionIndexVisibilityValues: () => sdkListSectionIndexVisibilityValues,
  sdkListSectionSpacingWithListSectionSpacingValues: () => sdkListSectionSpacingWithListSectionSpacingValues,
  sdkListStyleValues: () => sdkListStyleValues,
  sdkMapCameraKeyframeAnimatorValues: () => sdkMapCameraKeyframeAnimatorValues,
  sdkMapControlVisibilityValues: () => sdkMapControlVisibilityValues,
  sdkMapFeatureSelectionAccessoryValues: () => sdkMapFeatureSelectionAccessoryValues,
  sdkMapStyleValues: () => sdkMapStyleValues,
  sdkMaterialActiveAppearanceValues: () => sdkMaterialActiveAppearanceValues,
  sdkMenuActionDismissBehaviorValues: () => sdkMenuActionDismissBehaviorValues,
  sdkMenuIndicatorValues: () => sdkMenuIndicatorValues,
  sdkMenuOrderValues: () => sdkMenuOrderValues,
  sdkMenuStyleValues: () => sdkMenuStyleValues,
  sdkMultilineTextAlignmentWithStrategyValues: () => sdkMultilineTextAlignmentWithStrategyValues,
  sdkMultilineTextAlignmentWithTextAlignmentValues: () => sdkMultilineTextAlignmentWithTextAlignmentValues,
  sdkNavigationBarTitleDisplayModeValues: () => sdkNavigationBarTitleDisplayModeValues,
  sdkNavigationLinkIndicatorVisibilityValues: () => sdkNavigationLinkIndicatorVisibilityValues,
  sdkNavigationSplitViewStyleValues: () => sdkNavigationSplitViewStyleValues,
  sdkNavigationTransitionValues: () => sdkNavigationTransitionValues,
  sdkNavigationViewStyleValues: () => sdkNavigationViewStyleValues,
  sdkOnKeyPressValues: () => sdkOnKeyPressValues,
  sdkOnScrollPhaseChangeValues: () => sdkOnScrollPhaseChangeValues,
  sdkPaddingWithSetValues: () => sdkPaddingWithSetValues,
  sdkPaletteSelectionEffectValues: () => sdkPaletteSelectionEffectValues,
  sdkPayLaterViewActionValues: () => sdkPayLaterViewActionValues,
  sdkPayLaterViewDisplayStyleValues: () => sdkPayLaterViewDisplayStyleValues,
  sdkPayWithApplePayButtonStyleValues: () => sdkPayWithApplePayButtonStyleValues,
  sdkPersistentSystemOverlaysValues: () => sdkPersistentSystemOverlaysValues,
  sdkPhotosPickerDisabledCapabilitiesValues: () => sdkPhotosPickerDisabledCapabilitiesValues,
  sdkPhotosPickerMetadataOptionsValues: () => sdkPhotosPickerMetadataOptionsValues,
  sdkPhotosPickerStyleValues: () => sdkPhotosPickerStyleValues,
  sdkPickerStyleValues: () => sdkPickerStyleValues,
  sdkPreferencePreferredColorSchemeValues: () => sdkPreferencePreferredColorSchemeValues,
  sdkPreferredColorSchemeValues: () => sdkPreferredColorSchemeValues,
  sdkPresentationBackgroundInteractionValues: () => sdkPresentationBackgroundInteractionValues,
  sdkPresentationBackgroundValues: () => sdkPresentationBackgroundValues,
  sdkPresentationCompactAdaptationWithPresentationAdaptationValues: () => sdkPresentationCompactAdaptationWithPresentationAdaptationValues,
  sdkPresentationContentInteractionValues: () => sdkPresentationContentInteractionValues,
  sdkPresentationDetentsValues: () => sdkPresentationDetentsValues,
  sdkPresentationDragIndicatorValues: () => sdkPresentationDragIndicatorValues,
  sdkPresentationPlacementValues: () => sdkPresentationPlacementValues,
  sdkPresentationSizingValues: () => sdkPresentationSizingValues,
  sdkPreviewInterfaceOrientationValues: () => sdkPreviewInterfaceOrientationValues,
  sdkPreviewLayoutValues: () => sdkPreviewLayoutValues,
  sdkProductDescriptionValues: () => sdkProductDescriptionValues,
  sdkProductViewStyleValues: () => sdkProductViewStyleValues,
  sdkProgressViewStyleValues: () => sdkProgressViewStyleValues,
  sdkRealityViewCameraControlsValues: () => sdkRealityViewCameraControlsValues,
  sdkRealityViewLayoutBehaviorValues: () => sdkRealityViewLayoutBehaviorValues,
  sdkRedactedValues: () => sdkRedactedValues,
  sdkSafeAreaPaddingWithSetValues: () => sdkSafeAreaPaddingWithSetValues,
  sdkScenePaddingWithSetValues: () => sdkScenePaddingWithSetValues,
  sdkScrollContentBackgroundValues: () => sdkScrollContentBackgroundValues,
  sdkScrollDismissesKeyboardValues: () => sdkScrollDismissesKeyboardValues,
  sdkScrollTargetBehaviorValues: () => sdkScrollTargetBehaviorValues,
  sdkScrollTransitionValues: () => sdkScrollTransitionValues,
  sdkSearchDictationBehaviorValues: () => sdkSearchDictationBehaviorValues,
  sdkSearchPresentationToolbarBehaviorValues: () => sdkSearchPresentationToolbarBehaviorValues,
  sdkSearchToolbarBehaviorValues: () => sdkSearchToolbarBehaviorValues,
  sdkShortcutsLinkStyleValues: () => sdkShortcutsLinkStyleValues,
  sdkSignInWithAppleButtonStyleValues: () => sdkSignInWithAppleButtonStyleValues,
  sdkSiriTipViewStyleValues: () => sdkSiriTipViewStyleValues,
  sdkSliderThumbVisibilityValues: () => sdkSliderThumbVisibilityValues,
  sdkSpringLoadingBehaviorValues: () => sdkSpringLoadingBehaviorValues,
  sdkSubmitLabelValues: () => sdkSubmitLabelValues,
  sdkSubscriptionOfferViewStyleValues: () => sdkSubscriptionOfferViewStyleValues,
  sdkSubscriptionStoreButtonLabelValues: () => sdkSubscriptionStoreButtonLabelValues,
  sdkSubscriptionStoreControlBackgroundValues: () => sdkSubscriptionStoreControlBackgroundValues,
  sdkSubscriptionStoreControlStyleValues: () => sdkSubscriptionStoreControlStyleValues,
  sdkSubscriptionStoreOptionGroupStyleValues: () => sdkSubscriptionStoreOptionGroupStyleValues,
  sdkSubscriptionStorePickerItemBackgroundValues: () => sdkSubscriptionStorePickerItemBackgroundValues,
  sdkSubscriptionStorePolicyForegroundStyleValues: () => sdkSubscriptionStorePolicyForegroundStyleValues,
  sdkSymbolColorRenderingModeValues: () => sdkSymbolColorRenderingModeValues,
  sdkSymbolEffectValues: () => sdkSymbolEffectValues,
  sdkSymbolRenderingModeValues: () => sdkSymbolRenderingModeValues,
  sdkSymbolVariableValueModeValues: () => sdkSymbolVariableValueModeValues,
  sdkSymbolVariantValues: () => sdkSymbolVariantValues,
  sdkTabBarMinimizeBehaviorValues: () => sdkTabBarMinimizeBehaviorValues,
  sdkTabViewSearchActivationValues: () => sdkTabViewSearchActivationValues,
  sdkTabViewStyleValues: () => sdkTabViewStyleValues,
  sdkTableColumnHeadersValues: () => sdkTableColumnHeadersValues,
  sdkTableStyleValues: () => sdkTableStyleValues,
  sdkTextCaseValues: () => sdkTextCaseValues,
  sdkTextContentTypeValues: () => sdkTextContentTypeValues,
  sdkTextEditorStyleValues: () => sdkTextEditorStyleValues,
  sdkTextFieldStyleValues: () => sdkTextFieldStyleValues,
  sdkTextInputAutocapitalizationValues: () => sdkTextInputAutocapitalizationValues,
  sdkTextInputBorderShapeValues: () => sdkTextInputBorderShapeValues,
  sdkTextSelectionAffinityValues: () => sdkTextSelectionAffinityValues,
  sdkTextSelectionValues: () => sdkTextSelectionValues,
  sdkTintWithOptionalColorValues: () => sdkTintWithOptionalColorValues,
  sdkToggleStyleValues: () => sdkToggleStyleValues,
  sdkToolbarRoleValues: () => sdkToolbarRoleValues,
  sdkToolbarTitleDisplayModeValues: () => sdkToolbarTitleDisplayModeValues,
  sdkToolbarWithRemovingValues: () => sdkToolbarWithRemovingValues,
  sdkTransformPreferencePreferredColorSchemeValues: () => sdkTransformPreferencePreferredColorSchemeValues,
  sdkTransitionValues: () => sdkTransitionValues,
  sdkTruncationModeValues: () => sdkTruncationModeValues,
  sdkVerifyIdentityWithWalletButtonStyleValues: () => sdkVerifyIdentityWithWalletButtonStyleValues,
  sdkVisualEffectValues: () => sdkVisualEffectValues,
  sdkWebViewBackForwardNavigationGesturesValues: () => sdkWebViewBackForwardNavigationGesturesValues,
  sdkWebViewContentBackgroundValues: () => sdkWebViewContentBackgroundValues,
  sdkWebViewElementFullscreenBehaviorValues: () => sdkWebViewElementFullscreenBehaviorValues,
  sdkWebViewLinkPreviewsValues: () => sdkWebViewLinkPreviewsValues,
  sdkWebViewMagnificationGesturesValues: () => sdkWebViewMagnificationGesturesValues,
  sdkWebViewTextSelectionValues: () => sdkWebViewTextSelectionValues,
  sdkWindowToolbarFullScreenVisibilityValues: () => sdkWindowToolbarFullScreenVisibilityValues,
  sdkWritingDirectionValues: () => sdkWritingDirectionValues,
  sdkWritingToolsAffordanceVisibilityValues: () => sdkWritingToolsAffordanceVisibilityValues,
  sdkWritingToolsBehaviorValues: () => sdkWritingToolsBehaviorValues
});
module.exports = __toCommonJS(controlTypes_exports);
var glassEffects = [
  "regular",
  "clear",
  "identity"
];
var glassEffectShapes = [
  "capsule",
  "circle",
  "containerRelativeShape",
  "ellipse",
  "rectangle",
  "roundedRectangle"
];
var materials = [
  "ultraThin",
  "thin",
  "regular",
  "thick",
  "ultraThick"
];
var sdkAccentColorValues = [
  "accentColor",
  "red",
  "orange",
  "yellow",
  "green",
  "mint",
  "teal",
  "cyan",
  "blue",
  "indigo",
  "purple",
  "pink",
  "brown",
  "white",
  "gray",
  "black",
  "clear",
  "primary",
  "secondary"
];
var sdkAccessibilityActivationPointWithUnitPointValues = [
  "zero",
  "center",
  "leading",
  "trailing",
  "top",
  "bottom",
  "topLeading",
  "topTrailing",
  "bottomLeading",
  "bottomTrailing"
];
var sdkAccessibilityAddTraitsValues = [
  "isButton",
  "isHeader",
  "isSelected",
  "isLink",
  "isSearchField",
  "isImage",
  "playsSound",
  "isKeyboardKey",
  "isStaticText",
  "isSummaryElement",
  "updatesFrequently",
  "startsMediaSession",
  "allowsDirectInteraction",
  "causesPageTurn",
  "isModal",
  "isToggle",
  "isTabBar"
];
var sdkAccessibilityAdjustableActionValues = [
  "increment",
  "decrement"
];
var sdkAccessibilityElementValues = [
  "ignore",
  "contain",
  "combine"
];
var sdkAccessibilityHeadingValues = [
  "unspecified",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6"
];
var sdkAccessibilityRemoveTraitsValues = [
  "isButton",
  "isHeader",
  "isSelected",
  "isLink",
  "isSearchField",
  "isImage",
  "playsSound",
  "isKeyboardKey",
  "isStaticText",
  "isSummaryElement",
  "updatesFrequently",
  "startsMediaSession",
  "allowsDirectInteraction",
  "causesPageTurn",
  "isModal",
  "isToggle",
  "isTabBar"
];
var sdkAccessibilityScrollActionValues = [
  "top",
  "leading",
  "bottom",
  "trailing"
];
var sdkAccessibilityTextContentTypeValues = [
  "plain",
  "console",
  "fileSystem",
  "messaging",
  "narrative",
  "sourceCode",
  "spreadsheet",
  "wordProcessing"
];
var sdkAccessibilityWithActivationPointValues = [
  "zero",
  "center",
  "leading",
  "trailing",
  "top",
  "bottom",
  "topLeading",
  "topTrailing",
  "bottomLeading",
  "bottomTrailing"
];
var sdkAccessibilityWithAddTraitsValues = [
  "isButton",
  "isHeader",
  "isSelected",
  "isLink",
  "isSearchField",
  "isImage",
  "playsSound",
  "isKeyboardKey",
  "isStaticText",
  "isSummaryElement",
  "updatesFrequently",
  "startsMediaSession",
  "allowsDirectInteraction",
  "causesPageTurn",
  "isModal",
  "isToggle",
  "isTabBar"
];
var sdkAccessibilityWithRemoveTraitsValues = [
  "isButton",
  "isHeader",
  "isSelected",
  "isLink",
  "isSearchField",
  "isImage",
  "playsSound",
  "isKeyboardKey",
  "isStaticText",
  "isSummaryElement",
  "updatesFrequently",
  "startsMediaSession",
  "allowsDirectInteraction",
  "causesPageTurn",
  "isModal",
  "isToggle",
  "isTabBar"
];
var sdkAddPassToWalletButtonStyleValues = [
  "black",
  "blackOutline"
];
var sdkAllowedDynamicRangeValues = [
  "standard",
  "constrainedHigh",
  "high"
];
var sdkAnimationValues = [
  "default",
  "interpolatingSpring",
  "spring",
  "interactiveSpring",
  "smooth",
  "snappy",
  "bouncy",
  "easeInOut",
  "easeIn",
  "easeOut",
  "linear"
];
var sdkAsyncImageURLSessionValues = [
  "shared"
];
var sdkAutocapitalizationValues = [
  "allCharacters",
  "none",
  "sentences",
  "words"
];
var sdkBackgroundStyleValues = [
  "placeholder",
  "link",
  "selection",
  "windowBackground",
  "fill",
  "regularMaterial",
  "thickMaterial",
  "thinMaterial",
  "ultraThinMaterial",
  "ultraThickMaterial",
  "bar",
  "primary",
  "secondary",
  "tertiary",
  "quaternary",
  "quinary",
  "red",
  "orange",
  "yellow",
  "green",
  "mint",
  "teal",
  "cyan",
  "blue",
  "indigo",
  "purple",
  "pink",
  "brown",
  "white",
  "gray",
  "black",
  "clear",
  "separator",
  "background",
  "foreground",
  "tint"
];
var sdkBadgeProminenceValues = [
  "decreased",
  "standard",
  "increased"
];
var sdkBlendModeValues = [
  "normal",
  "multiply",
  "screen",
  "overlay",
  "darken",
  "lighten",
  "colorDodge",
  "colorBurn",
  "softLight",
  "hardLight",
  "difference",
  "exclusion",
  "hue",
  "saturation",
  "color",
  "luminosity",
  "sourceAtop",
  "destinationOver",
  "destinationOut",
  "plusDarker",
  "plusLighter"
];
var sdkButtonBorderShapeValues = [
  "automatic",
  "capsule",
  "roundedRectangle",
  "circle"
];
var sdkButtonRepeatBehaviorValues = [
  "automatic",
  "enabled",
  "disabled"
];
var sdkButtonSizingValues = [
  "automatic",
  "flexible",
  "fitted"
];
var sdkButtonStyleValues = [
  "automatic",
  "glass",
  "borderless",
  "glassProminent",
  "plain",
  "bordered",
  "borderedProminent"
];
var sdkClipShapeValues = [
  "buttonBorder",
  "rect",
  "capsule",
  "ellipse",
  "circle",
  "containerRelative",
  "textInputBorder"
];
var sdkColorMultiplyValues = [
  "accentColor",
  "red",
  "orange",
  "yellow",
  "green",
  "mint",
  "teal",
  "cyan",
  "blue",
  "indigo",
  "purple",
  "pink",
  "brown",
  "white",
  "gray",
  "black",
  "clear",
  "primary",
  "secondary"
];
var sdkColorSchemeValues = [
  "light",
  "dark"
];
var sdkContainerShapeValues = [
  "buttonBorder",
  "rect",
  "capsule",
  "ellipse",
  "circle",
  "containerRelative",
  "textInputBorder"
];
var sdkContentShapeValues = [
  "buttonBorder",
  "rect",
  "capsule",
  "ellipse",
  "circle",
  "containerRelative",
  "textInputBorder"
];
var sdkContentTransitionValues = [
  "symbolEffect",
  "identity",
  "opacity",
  "interpolate"
];
var sdkControlGroupStyleValues = [
  "palette",
  "automatic",
  "navigation",
  "menu",
  "compactMenu"
];
var sdkControlSizeValues = [
  "mini",
  "small",
  "regular",
  "large",
  "extraLarge"
];
var sdkDatePickerStyleValues = [
  "wheel",
  "automatic",
  "graphical",
  "compact"
];
var sdkDefaultAdaptableTabBarPlacementValues = [
  "automatic",
  "tabBar",
  "sidebar"
];
var sdkDefaultAppStorageValues = [
  "standard"
];
var sdkDefaultHoverEffectValues = [
  "automatic",
  "highlight",
  "lift"
];
var sdkDefaultScrollAnchorWithOptionalUnitPointValues = [
  "zero",
  "center",
  "leading",
  "trailing",
  "top",
  "bottom",
  "topLeading",
  "topTrailing",
  "bottomLeading",
  "bottomTrailing"
];
var sdkDefaultTabBarPlacementValues = [
  "automatic",
  "tabBar",
  "sidebar"
];
var sdkDefersSystemGesturesValues = [
  "top",
  "leading",
  "bottom",
  "trailing",
  "all",
  "horizontal",
  "vertical"
];
var sdkDisclosureGroupStyleValues = [
  "automatic"
];
var sdkDropConfigurationValues = [
  "cancel",
  "forbidden",
  "copy",
  "move"
];
var sdkDynamicTypeSizeValues = [
  "xSmall",
  "small",
  "medium",
  "large",
  "xLarge",
  "xxLarge",
  "xxxLarge",
  "accessibility1",
  "accessibility2",
  "accessibility3",
  "accessibility4",
  "accessibility5"
];
var sdkEdgesIgnoringSafeAreaValues = [
  "top",
  "leading",
  "bottom",
  "trailing",
  "all",
  "horizontal",
  "vertical"
];
var sdkEnvironmentAllowedDynamicRangeValues = [
  "standard",
  "constrainedHigh",
  "high"
];
var sdkEnvironmentBackgroundMaterialValues = [
  "regular",
  "thick",
  "thin",
  "ultraThin",
  "ultraThick",
  "bar"
];
var sdkEnvironmentBackgroundProminenceValues = [
  "standard",
  "increased"
];
var sdkEnvironmentBadgeProminenceValues = [
  "decreased",
  "standard",
  "increased"
];
var sdkEnvironmentCalendarValues = [
  "autoupdatingCurrent",
  "current"
];
var sdkEnvironmentColorSchemeValues = [
  "light",
  "dark"
];
var sdkEnvironmentContentTransitionValues = [
  "symbolEffect",
  "identity",
  "opacity",
  "interpolate"
];
var sdkEnvironmentControlSizeValues = [
  "mini",
  "small",
  "regular",
  "large",
  "extraLarge"
];
var sdkEnvironmentDynamicTypeSizeValues = [
  "xSmall",
  "small",
  "medium",
  "large",
  "xLarge",
  "xxLarge",
  "xxxLarge",
  "accessibility1",
  "accessibility2",
  "accessibility3",
  "accessibility4",
  "accessibility5"
];
var sdkEnvironmentFontValues = [
  "largeTitle",
  "title",
  "title2",
  "title3",
  "headline",
  "subheadline",
  "body",
  "callout",
  "footnote",
  "caption",
  "caption2",
  "default"
];
var sdkEnvironmentHeaderProminenceValues = [
  "standard",
  "increased"
];
var sdkEnvironmentHorizontalScrollBounceBehaviorValues = [
  "automatic",
  "always",
  "basedOnSize"
];
var sdkEnvironmentHorizontalScrollIndicatorVisibilityValues = [
  "automatic",
  "visible",
  "hidden",
  "never"
];
var sdkEnvironmentHorizontalSizeClassValues = [
  "compact",
  "regular"
];
var sdkEnvironmentImageScaleValues = [
  "small",
  "medium",
  "large"
];
var sdkEnvironmentLabelsVisibilityValues = [
  "automatic",
  "visible",
  "hidden"
];
var sdkEnvironmentLayoutDirectionValues = [
  "leftToRight",
  "rightToLeft"
];
var sdkEnvironmentLegibilityWeightValues = [
  "regular",
  "bold"
];
var sdkEnvironmentLineHeightValues = [
  "variable",
  "normal",
  "tight",
  "loose"
];
var sdkEnvironmentLocaleValues = [
  "autoupdatingCurrent",
  "current"
];
var sdkEnvironmentMaterialActiveAppearanceValues = [
  "automatic",
  "active",
  "matchWindow"
];
var sdkEnvironmentMenuIndicatorVisibilityValues = [
  "automatic",
  "visible",
  "hidden"
];
var sdkEnvironmentMenuOrderValues = [
  "automatic",
  "priority",
  "fixed"
];
var sdkEnvironmentMultilineTextAlignmentValues = [
  "leading",
  "center",
  "trailing"
];
var sdkEnvironmentRealityViewCameraControlsValues = [
  "dolly",
  "none",
  "orbit",
  "pan",
  "tilt"
];
var sdkEnvironmentRedactionReasonsValues = [
  "placeholder",
  "privacy",
  "invalidated"
];
var sdkEnvironmentScenePhaseValues = [
  "background",
  "inactive",
  "active"
];
var sdkEnvironmentScrollDismissesKeyboardModeValues = [
  "automatic",
  "immediately",
  "interactively",
  "never"
];
var sdkEnvironmentSidebarRowSizeValues = [
  "small",
  "medium",
  "large"
];
var sdkEnvironmentSizeCategoryValues = [
  "extraSmall",
  "small",
  "medium",
  "large",
  "extraLarge",
  "extraExtraLarge",
  "extraExtraExtraLarge",
  "accessibilityMedium",
  "accessibilityLarge",
  "accessibilityExtraLarge",
  "accessibilityExtraExtraLarge",
  "accessibilityExtraExtraExtraLarge"
];
var sdkEnvironmentSymbolColorRenderingModeValues = [
  "flat",
  "gradient"
];
var sdkEnvironmentSymbolRenderingModeValues = [
  "monochrome",
  "multicolor",
  "hierarchical",
  "palette"
];
var sdkEnvironmentSymbolVariableValueModeValues = [
  "color",
  "draw"
];
var sdkEnvironmentSymbolVariantsValues = [
  "none",
  "circle",
  "square",
  "rectangle",
  "fill",
  "slash"
];
var sdkEnvironmentTextCaseValues = [
  "uppercase",
  "lowercase"
];
var sdkEnvironmentTextSelectionAffinityValues = [
  "automatic",
  "upstream",
  "downstream"
];
var sdkEnvironmentTimeZoneValues = [
  "autoupdatingCurrent",
  "current",
  "gmt"
];
var sdkEnvironmentTruncationModeValues = [
  "head",
  "tail",
  "middle"
];
var sdkEnvironmentVerticalScrollBounceBehaviorValues = [
  "automatic",
  "always",
  "basedOnSize"
];
var sdkEnvironmentVerticalScrollIndicatorVisibilityValues = [
  "automatic",
  "visible",
  "hidden",
  "never"
];
var sdkEnvironmentVerticalSizeClassValues = [
  "compact",
  "regular"
];
var sdkFileDialogBrowserOptionsValues = [
  "enumeratePackages",
  "includeHiddenFiles",
  "displayFileExtensions"
];
var sdkFontValues = [
  "largeTitle",
  "title",
  "title2",
  "title3",
  "headline",
  "subheadline",
  "body",
  "callout",
  "footnote",
  "caption",
  "caption2",
  "default"
];
var sdkFontDesignWithOptionalDesignValues = [
  "default",
  "serif",
  "rounded",
  "monospaced"
];
var sdkFontWeightWithOptionalWeightValues = [
  "ultraLight",
  "thin",
  "light",
  "regular",
  "medium",
  "semibold",
  "bold",
  "heavy",
  "black"
];
var sdkFontWidthValues = [
  "compressed",
  "condensed",
  "standard",
  "expanded"
];
var sdkForegroundColorValues = [
  "accentColor",
  "red",
  "orange",
  "yellow",
  "green",
  "mint",
  "teal",
  "cyan",
  "blue",
  "indigo",
  "purple",
  "pink",
  "brown",
  "white",
  "gray",
  "black",
  "clear",
  "primary",
  "secondary"
];
var sdkFormStyleValues = [
  "columns",
  "grouped",
  "automatic"
];
var sdkGaugeStyleValues = [
  "accessoryCircularCapacity",
  "linearCapacity",
  "accessoryLinear",
  "accessoryLinearCapacity",
  "automatic",
  "accessoryCircular"
];
var sdkGlassEffectTransitionValues = [
  "matchedGeometry",
  "materialize",
  "identity"
];
var sdkGlassEffectWithGlassValues = [
  "regular",
  "clear",
  "identity"
];
var sdkGridCellAnchorValues = [
  "zero",
  "center",
  "leading",
  "trailing",
  "top",
  "bottom",
  "topLeading",
  "topTrailing",
  "bottomLeading",
  "bottomTrailing"
];
var sdkGridCellUnsizedAxesValues = [
  "horizontal",
  "vertical"
];
var sdkGridColumnAlignmentValues = [
  "leading",
  "center",
  "trailing",
  "listRowSeparatorLeading",
  "listRowSeparatorTrailing"
];
var sdkGroupBoxStyleValues = [
  "automatic"
];
var sdkHandlesGameControllerEventsValues = [
  "gamepad"
];
var sdkHeaderProminenceValues = [
  "standard",
  "increased"
];
var sdkHoverEffectWithHoverEffectValues = [
  "automatic",
  "highlight",
  "lift"
];
var sdkHoverEffectWithHoverEffectFromSwiftUICoreValues = [
  "automatic",
  "highlight",
  "lift"
];
var sdkHueRotationValues = [
  "zero"
];
var sdkIgnoresSafeAreaWithSafeAreaRegionsValues = [
  "container",
  "keyboard",
  "all"
];
var sdkImageScaleValues = [
  "small",
  "medium",
  "large"
];
var sdkIndexViewStyleValues = [
  "page"
];
var sdkKeyboardShortcutWithKeyboardShortcutValues = [
  "defaultAction",
  "cancelAction"
];
var sdkKeyboardShortcutWithOptionalKeyboardShortcutValues = [
  "defaultAction",
  "cancelAction"
];
var sdkKeyboardTypeValues = [
  "URL",
  "alphabet",
  "asciiCapable",
  "asciiCapableNumberPad",
  "decimalPad",
  "default",
  "emailAddress",
  "namePhonePad",
  "numberPad",
  "numbersAndPunctuation",
  "phonePad",
  "twitter",
  "webSearch"
];
var sdkLabeledContentStyleValues = [
  "automatic"
];
var sdkLabelStyleValues = [
  "automatic",
  "iconOnly",
  "titleAndIcon",
  "titleOnly"
];
var sdkLabelsVisibilityValues = [
  "automatic",
  "visible",
  "hidden"
];
var sdkLayoutDirectionBehaviorValues = [
  "fixed",
  "mirrors"
];
var sdkLineHeightValues = [
  "variable",
  "normal",
  "tight",
  "loose"
];
var sdkListItemTintWithOptionalColorValues = [
  "accentColor",
  "red",
  "orange",
  "yellow",
  "green",
  "mint",
  "teal",
  "cyan",
  "blue",
  "indigo",
  "purple",
  "pink",
  "brown",
  "white",
  "gray",
  "black",
  "clear",
  "primary",
  "secondary"
];
var sdkListItemTintWithOptionalListItemTintValues = [
  "monochrome"
];
var sdkListSectionIndexVisibilityValues = [
  "automatic",
  "visible",
  "hidden"
];
var sdkListSectionSpacingWithListSectionSpacingValues = [
  "default",
  "compact"
];
var sdkListStyleValues = [
  "automatic",
  "sidebar",
  "inset",
  "grouped",
  "insetGrouped",
  "plain"
];
var sdkMapCameraKeyframeAnimatorValues = [
  "distance",
  "heading",
  "pitch"
];
var sdkMapControlVisibilityValues = [
  "automatic",
  "visible",
  "hidden"
];
var sdkMapFeatureSelectionAccessoryValues = [
  "automatic",
  "callout",
  "sheet",
  "caption"
];
var sdkMapStyleValues = [
  "standard",
  "imagery",
  "hybrid"
];
var sdkMaterialActiveAppearanceValues = [
  "automatic",
  "active",
  "matchWindow"
];
var sdkMenuActionDismissBehaviorValues = [
  "automatic",
  "enabled",
  "disabled"
];
var sdkMenuIndicatorValues = [
  "automatic",
  "visible",
  "hidden"
];
var sdkMenuOrderValues = [
  "automatic",
  "priority",
  "fixed"
];
var sdkMenuStyleValues = [
  "button",
  "automatic",
  "borderlessButton"
];
var sdkMultilineTextAlignmentWithStrategyValues = [
  "layoutBased",
  "writingDirectionBased",
  "default"
];
var sdkMultilineTextAlignmentWithTextAlignmentValues = [
  "leading",
  "center",
  "trailing"
];
var sdkNavigationBarTitleDisplayModeValues = [
  "automatic",
  "inline",
  "large"
];
var sdkNavigationLinkIndicatorVisibilityValues = [
  "automatic",
  "visible",
  "hidden"
];
var sdkNavigationSplitViewStyleValues = [
  "balanced",
  "prominentDetail",
  "automatic"
];
var sdkNavigationTransitionValues = [
  "automatic",
  "crossFade"
];
var sdkNavigationViewStyleValues = [
  "columns",
  "automatic",
  "stack"
];
var sdkOnKeyPressValues = [
  "handled",
  "ignored"
];
var sdkOnScrollPhaseChangeValues = [
  "idle",
  "tracking",
  "interacting",
  "decelerating",
  "animating"
];
var sdkPaddingWithSetValues = [
  "top",
  "leading",
  "bottom",
  "trailing",
  "all",
  "horizontal",
  "vertical"
];
var sdkPaletteSelectionEffectValues = [
  "automatic",
  "custom"
];
var sdkPayLaterViewActionValues = [
  "learnMore",
  "calculator"
];
var sdkPayLaterViewDisplayStyleValues = [
  "standard",
  "badge",
  "checkout",
  "price"
];
var sdkPayWithApplePayButtonStyleValues = [
  "white",
  "whiteOutline",
  "black",
  "automatic"
];
var sdkPersistentSystemOverlaysValues = [
  "automatic",
  "visible",
  "hidden"
];
var sdkPhotosPickerDisabledCapabilitiesValues = [
  "collectionNavigation",
  "search",
  "selectionActions",
  "sensitivityAnalysisIntervention",
  "stagingArea"
];
var sdkPhotosPickerMetadataOptionsValues = [
  "removeCaptions",
  "removeLocation"
];
var sdkPhotosPickerStyleValues = [
  "presentation",
  "inline",
  "compact"
];
var sdkPickerStyleValues = [
  "wheel",
  "inline",
  "automatic",
  "segmented",
  "tabs",
  "palette",
  "navigationLink",
  "menu"
];
var sdkPreferencePreferredColorSchemeValues = [
  "light",
  "dark"
];
var sdkPreferredColorSchemeValues = [
  "light",
  "dark"
];
var sdkPresentationBackgroundValues = [
  "placeholder",
  "link",
  "selection",
  "windowBackground",
  "fill",
  "regularMaterial",
  "thickMaterial",
  "thinMaterial",
  "ultraThinMaterial",
  "ultraThickMaterial",
  "bar",
  "primary",
  "secondary",
  "tertiary",
  "quaternary",
  "quinary",
  "red",
  "orange",
  "yellow",
  "green",
  "mint",
  "teal",
  "cyan",
  "blue",
  "indigo",
  "purple",
  "pink",
  "brown",
  "white",
  "gray",
  "black",
  "clear",
  "separator",
  "background",
  "foreground",
  "tint"
];
var sdkPresentationBackgroundInteractionValues = [
  "automatic",
  "enabled",
  "disabled"
];
var sdkPresentationCompactAdaptationWithPresentationAdaptationValues = [
  "automatic",
  "none",
  "popover",
  "sheet",
  "fullScreenCover"
];
var sdkPresentationContentInteractionValues = [
  "automatic",
  "resizes",
  "scrolls"
];
var sdkPresentationDetentsValues = [
  "medium",
  "large"
];
var sdkPresentationDragIndicatorValues = [
  "automatic",
  "visible",
  "hidden"
];
var sdkPresentationPlacementValues = [
  "automatic",
  "leading",
  "center",
  "trailing"
];
var sdkPresentationSizingValues = [
  "form",
  "page",
  "fitted",
  "automatic"
];
var sdkPreviewInterfaceOrientationValues = [
  "portrait",
  "portraitUpsideDown",
  "landscapeLeft",
  "landscapeRight"
];
var sdkPreviewLayoutValues = [
  "device",
  "sizeThatFits"
];
var sdkProductDescriptionValues = [
  "automatic",
  "visible",
  "hidden"
];
var sdkProductViewStyleValues = [
  "automatic",
  "regular",
  "large",
  "compact"
];
var sdkProgressViewStyleValues = [
  "linear",
  "circular",
  "automatic"
];
var sdkRealityViewCameraControlsValues = [
  "dolly",
  "none",
  "orbit",
  "pan",
  "tilt"
];
var sdkRealityViewLayoutBehaviorValues = [
  "flexible",
  "centered",
  "fixedSize"
];
var sdkRedactedValues = [
  "placeholder",
  "privacy",
  "invalidated"
];
var sdkSafeAreaPaddingWithSetValues = [
  "top",
  "leading",
  "bottom",
  "trailing",
  "all",
  "horizontal",
  "vertical"
];
var sdkScenePaddingWithSetValues = [
  "top",
  "leading",
  "bottom",
  "trailing",
  "all",
  "horizontal",
  "vertical"
];
var sdkScrollContentBackgroundValues = [
  "automatic",
  "visible",
  "hidden"
];
var sdkScrollDismissesKeyboardValues = [
  "automatic",
  "immediately",
  "interactively",
  "never"
];
var sdkScrollTargetBehaviorValues = [
  "paging",
  "viewAligned"
];
var sdkScrollTransitionValues = [
  "opacity",
  "scaleEffect"
];
var sdkSearchDictationBehaviorValues = [
  "automatic"
];
var sdkSearchPresentationToolbarBehaviorValues = [
  "automatic",
  "avoidHidingContent"
];
var sdkSearchToolbarBehaviorValues = [
  "automatic",
  "minimize"
];
var sdkShortcutsLinkStyleValues = [
  "automatic",
  "automaticOutline",
  "light",
  "lightOutline",
  "dark",
  "darkOutline"
];
var sdkSignInWithAppleButtonStyleValues = [
  "black",
  "white",
  "whiteOutline"
];
var sdkSiriTipViewStyleValues = [
  "automatic",
  "light",
  "dark"
];
var sdkSliderThumbVisibilityValues = [
  "automatic",
  "visible",
  "hidden"
];
var sdkSpringLoadingBehaviorValues = [
  "automatic",
  "enabled",
  "disabled"
];
var sdkSubmitLabelValues = [
  "done",
  "go",
  "send",
  "join",
  "route",
  "search",
  "return",
  "next",
  "continue"
];
var sdkSubscriptionOfferViewStyleValues = [
  "automatic",
  "compact"
];
var sdkSubscriptionStoreButtonLabelValues = [
  "automatic",
  "singleLine",
  "multiline",
  "action",
  "displayName",
  "price"
];
var sdkSubscriptionStoreControlBackgroundValues = [
  "automatic",
  "gradientMaterial",
  "gradientMaterialOnScroll"
];
var sdkSubscriptionStoreControlStyleValues = [
  "pagedProminentPicker",
  "pagedPicker",
  "automatic",
  "compactPicker",
  "prominentPicker",
  "picker",
  "buttons"
];
var sdkSubscriptionStoreOptionGroupStyleValues = [
  "automatic",
  "tabs",
  "links"
];
var sdkSubscriptionStorePickerItemBackgroundValues = [
  "placeholder",
  "link",
  "selection",
  "windowBackground",
  "fill",
  "regularMaterial",
  "thickMaterial",
  "thinMaterial",
  "ultraThinMaterial",
  "ultraThickMaterial",
  "bar",
  "primary",
  "secondary",
  "tertiary",
  "quaternary",
  "quinary",
  "red",
  "orange",
  "yellow",
  "green",
  "mint",
  "teal",
  "cyan",
  "blue",
  "indigo",
  "purple",
  "pink",
  "brown",
  "white",
  "gray",
  "black",
  "clear",
  "separator",
  "background",
  "foreground",
  "tint"
];
var sdkSubscriptionStorePolicyForegroundStyleValues = [
  "placeholder",
  "link",
  "selection",
  "windowBackground",
  "fill",
  "regularMaterial",
  "thickMaterial",
  "thinMaterial",
  "ultraThinMaterial",
  "ultraThickMaterial",
  "bar",
  "primary",
  "secondary",
  "tertiary",
  "quaternary",
  "quinary",
  "red",
  "orange",
  "yellow",
  "green",
  "mint",
  "teal",
  "cyan",
  "blue",
  "indigo",
  "purple",
  "pink",
  "brown",
  "white",
  "gray",
  "black",
  "clear",
  "separator",
  "background",
  "foreground",
  "tint"
];
var sdkSymbolColorRenderingModeValues = [
  "flat",
  "gradient"
];
var sdkSymbolEffectValues = [
  "pulse",
  "bounce",
  "variableColor",
  "scale",
  "wiggle",
  "rotate",
  "breathe"
];
var sdkSymbolRenderingModeValues = [
  "monochrome",
  "multicolor",
  "hierarchical",
  "palette"
];
var sdkSymbolVariableValueModeValues = [
  "color",
  "draw"
];
var sdkSymbolVariantValues = [
  "none",
  "circle",
  "square",
  "rectangle",
  "fill",
  "slash"
];
var sdkTabBarMinimizeBehaviorValues = [
  "automatic",
  "onScrollDown",
  "onScrollUp",
  "never"
];
var sdkTableColumnHeadersValues = [
  "automatic",
  "visible",
  "hidden"
];
var sdkTableStyleValues = [
  "inset",
  "automatic"
];
var sdkTabViewSearchActivationValues = [
  "automatic",
  "searchTabSelection"
];
var sdkTabViewStyleValues = [
  "sidebarAdaptable",
  "page",
  "tabBarOnly",
  "automatic"
];
var sdkTextCaseValues = [
  "uppercase",
  "lowercase"
];
var sdkTextContentTypeValues = [
  "URL",
  "addressCity",
  "addressCityAndState",
  "addressState",
  "birthdate",
  "birthdateDay",
  "birthdateMonth",
  "birthdateYear",
  "cellularEID",
  "cellularIMEI",
  "cellularIMEI1",
  "cellularIMEI2",
  "cellularNAL",
  "countryName",
  "creditCardExpiration",
  "creditCardExpirationMonth",
  "creditCardExpirationYear",
  "creditCardFamilyName",
  "creditCardGivenName",
  "creditCardMiddleName",
  "creditCardName",
  "creditCardNumber",
  "creditCardSecurityCode",
  "creditCardType",
  "dateTime",
  "emailAddress",
  "familyName",
  "flightNumber",
  "fullStreetAddress",
  "givenName",
  "jobTitle",
  "location",
  "middleName",
  "name",
  "namePrefix",
  "nameSuffix",
  "newPassword",
  "nickname",
  "oneTimeCode",
  "organizationName",
  "password",
  "postalCode",
  "shipmentTrackingNumber",
  "streetAddressLine1",
  "streetAddressLine2",
  "sublocality",
  "telephoneNumber",
  "username"
];
var sdkTextEditorStyleValues = [
  "automatic",
  "plain"
];
var sdkTextFieldStyleValues = [
  "automatic",
  "roundedBorder",
  "bordered",
  "plain"
];
var sdkTextInputAutocapitalizationValues = [
  "never",
  "words",
  "sentences",
  "characters"
];
var sdkTextInputBorderShapeValues = [
  "automatic",
  "capsule",
  "roundedRectangle"
];
var sdkTextSelectionValues = [
  "enabled",
  "disabled"
];
var sdkTextSelectionAffinityValues = [
  "automatic",
  "upstream",
  "downstream"
];
var sdkTintWithOptionalColorValues = [
  "accentColor",
  "red",
  "orange",
  "yellow",
  "green",
  "mint",
  "teal",
  "cyan",
  "blue",
  "indigo",
  "purple",
  "pink",
  "brown",
  "white",
  "gray",
  "black",
  "clear",
  "primary",
  "secondary"
];
var sdkToggleStyleValues = [
  "button",
  "automatic",
  "switch"
];
var sdkToolbarRoleValues = [
  "automatic",
  "navigationStack",
  "browser",
  "editor"
];
var sdkToolbarTitleDisplayModeValues = [
  "automatic",
  "large",
  "inlineLarge",
  "inline"
];
var sdkToolbarWithRemovingValues = [
  "sidebarToggle",
  "title",
  "search"
];
var sdkTransformPreferencePreferredColorSchemeValues = [
  "light",
  "dark"
];
var sdkTransitionValues = [
  "opacity",
  "slide",
  "identity",
  "scale"
];
var sdkTruncationModeValues = [
  "head",
  "tail",
  "middle"
];
var sdkVerifyIdentityWithWalletButtonStyleValues = [
  "black",
  "blackOutline"
];
var sdkVisualEffectValues = [
  "opacity",
  "scaleEffect"
];
var sdkWebViewBackForwardNavigationGesturesValues = [
  "automatic",
  "enabled",
  "disabled"
];
var sdkWebViewContentBackgroundValues = [
  "automatic",
  "visible",
  "hidden"
];
var sdkWebViewElementFullscreenBehaviorValues = [
  "automatic",
  "enabled",
  "disabled"
];
var sdkWebViewLinkPreviewsValues = [
  "automatic",
  "enabled",
  "disabled"
];
var sdkWebViewMagnificationGesturesValues = [
  "automatic",
  "enabled",
  "disabled"
];
var sdkWebViewTextSelectionValues = [
  "enabled",
  "disabled"
];
var sdkWindowToolbarFullScreenVisibilityValues = [
  "automatic"
];
var sdkWritingDirectionValues = [
  "layoutBased",
  "contentBased",
  "default"
];
var sdkWritingToolsAffordanceVisibilityValues = [
  "automatic",
  "visible",
  "hidden"
];
var sdkWritingToolsBehaviorValues = [
  "automatic",
  "complete",
  "limited",
  "disabled"
];
//# sourceMappingURL=controlTypes.js.map
